const initialState = {
    anchor: 'left',
    fazenda: [],
    totalItems: 0,
    open: false,
    id: '',
    nome: '',
    nome_proprietario: '',
    pessoa: '',
    codigo: '',
    data_inicio_cobranca: '',
    data_treinamento: '',
    dias_secagem: '',
    dias_parto: '',
    dias_bst: '',
    dias_pre_parto_novilha: '',
    dias_pre_parto: '',
    limite_peso_cio: '',
    limite_idade_cio: '',
    pev: '',
    listaUsuarios: [],
    usuarios_financeiro: [],
    login: '',
    senha: '',
    gera_cobranca: false,
    modulo_financeiro: false,
    modulo_zootecnico: false,
    empresa: [],
    arquivo: null,
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: '',
    id_motivo_desistencia: '',
    endereco: '',
    id_cidade: '',
    id_estado: '',
    data_importacao: '',
    data_treinamento_financeiro: '',
    gera_cobranca_financeiro: false,
    data_inicio_cobranca_financeiro: '',
    id_forma_ingresso: '',
    formasIngresso: []
};

export function fazenda(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_FAZENDA':
            return {
                ...state,
                fazenda: action.fazenda,
                totalItems: action.totalItems
            };
        case 'FAZENDA_DETAIL':
            return {
                ...state,
                id: action.id,
                nome: action.nome,
                nome_proprietario: action.nome_proprietario,
                pessoa: action.pessoa,
                codigo: action.codigo,
                data_inicio_cobranca: action.data_inicio_cobranca,
                data_treinamento: action.data_treinamento,
                dias_secagem: action.dias_secagem,
                dias_parto: action.dias_parto,
                dias_bst: action.dias_bst,
                dias_pre_parto_novilha: action.dias_pre_parto_novilha,
                dias_pre_parto: action.dias_pre_parto,
                limite_peso_cio: action.limite_peso_cio,
                limite_idade_cio: action.limite_idade_cio,
                pev: action.pev,
                gera_cobranca: action.gera_cobranca,
                modulo_financeiro: action.modulo_financeiro,
                modulo_zootecnico: action.modulo_zootecnico,
                listaUsuarios: action.listaUsuarios,
                usuarios_financeiro: action.usuarios_financeiro,
                id_empresa: action.id_empresa,
                empresa: action.empresa,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
                id_motivo_desistencia: action.id_motivo_desistencia,
                endereco: action.endereco,
                id_cidade: action.id_cidade,
                id_estado: action.id_estado,
                data_importacao: action.data_importacao,
                data_treinamento_financeiro: action.data_treinamento_financeiro,
                gera_cobranca_financeiro: action.gera_cobranca_financeiro,
                data_inicio_cobranca_financeiro: action.data_inicio_cobranca_financeiro,
                id_forma_ingresso: action.id_forma_ingresso
            };
        case "FAZENDA_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        case 'FETCHED_ALL_FORMA_INGRESSO':
            return {
                ...state,
                formasIngresso: action.formasIngresso
            };
        case 'FAZENDA_CLEAR':
            return {
                ...state,
                anchor: 'left',
                fazenda: [],
                totalItems: 0,
                open: false,
                id: '',
                nome: '',
                nome_proprietario: '',
                pessoa: '',
                codigo: '',
                data_inicio_cobranca: '',
                data_treinamento: '',
                dias_secagem: '',
                dias_parto: '',
                dias_bst: '',
                dias_pre_parto_novilha: '',
                dias_pre_parto: '',
                limite_peso_cio: '',
                limite_idade_cio: '',
                pev: '',
                listaUsuarios: [],
                usuarios_financeiro: [],
                login: '',
                senha: '',
                gera_cobranca: false,
                modulo_financeiro: false,
                modulo_zootecnico: false,
                empresa: [],
                arquivo: null,
                data_cadastro: '',
                usuario_cadastro: '',
                data_exclusao: '',
                usuario_exclusao: '',
                id_motivo_desistencia: '',
                endereco: '',
                id_cidade: '',
                id_estado: '',
                data_importacao: '',
                data_treinamento_financeiro: '',
                gera_cobranca_financeiro: false,
                data_inicio_cobranca_financeiro: '',
                id_forma_ingresso: '',
                formasIngresso: []
            };
        default:
            return state
    }
}
